var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg030Board = function Svg030Board(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 376V136c0-44.183 35.817-80 80-80h-60c-44.183 0-80 35.817-80 80v240c0 44.183 35.817 80 80 80h60c-44.183 0-80-35.817-80-80z",
    fill: "#a0eda2",
    "data-original": "#cee1f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M412 456H100c-44.183 0-80-35.817-80-80V136c0-44.183 35.817-80 80-80h312c44.183 0 80 35.817 80 80v240c0 44.183-35.817 80-80 80z",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 336,
    r: 40,
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376,
    cy: 176,
    r: 40,
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 296c0-66.274 53.726-120 120-120h40",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336 296 40 40m0-40-40 40M96 136l40 40m0-40-40 40",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#14d64d",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#ff5cf4"
  }));
};

export default Svg030Board;